import client from './client';

export const authApi = {
  login: (email, password, remember_me = false) =>
    client.post('/auth/login', { email, password, remember_me }),

  register: (email, password, name, role = 'client', invite_token = null) =>
    client.post('/auth/register', { email, password, name, role, invite_token }),

  me: () => client.get('/auth/me'),

  refresh: () => client.post('/auth/refresh'),

  changePassword: (current_password, new_password) =>
    client.put('/auth/change-password', { current_password, new_password }),

  changeUsername: (username) =>
    client.put('/auth/change-username', { username }),

  forgotPassword: (email) =>
    client.post('/auth/forgot-password', { email }),

  resetPassword: (email, code, new_password) =>
    client.post('/auth/reset-password', { email, code, new_password }),

  verifyEmail: (code) =>
    client.post('/auth/verify-email', { code }),

  resendVerification: () =>
    client.post('/auth/resend-verification'),
};
